import { NgModule } from '@angular/core';
import { S144gS144m01Component } from './s144g-s144m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S144gS144m01Component]
})
export class S144gModule { }

